import {RequiredPropertyError} from '../../../utils/errors/app';

export class NoCoachError extends RequiredPropertyError {
  constructor() {
    super('coach');
  }
}

export class NoCourseError extends RequiredPropertyError {
  constructor() {
    super('course');
  }
}

export class NoMembershipError extends RequiredPropertyError {
  constructor() {
    super('memberships');
  }
}
